import moment from 'moment'
import { useEffect } from 'react';
import { SelectOptionType } from 'types';
import { DateInput, Input, Select } from 'components'
import { TabBillStatusParams } from '../types';

type FilterRegisterBillServiceProps = {
  selected: TabBillStatusParams
  setSelected: (value: TabBillStatusParams) => void
}

export const FilterRegisterBillService = ({ selected, setSelected }: FilterRegisterBillServiceProps) => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();
  const dateTo = moment().startOf('year').format('YYYY-MM-DD');
  const dateEnd = new Date(year, month + 1, 0);

  const selectApproval: SelectOptionType[] = [
    { value: "1", label: "PENDING" },
    { value: "3", label: "REJECT" },
    { value: "4", label: "APPROVE" },
  ]
  const selectStatus: SelectOptionType[] = [
    { value: "1", label: "OPEN" },
    { value: "2", label: "CLOSE" },
    { value: "3", label: "CREDIT" },
  ]
  const sortedSelectApproval = selectApproval.sort((a, b) => parseInt(b.value) - parseInt(a.value));
  const sortedSelectStatus = selectStatus.sort((a, b) => parseInt(b.value) - parseInt(a.value));
  const allOption = { value: "", label: "All" };

  useEffect(() => {
    if(selected?.start_date === "") { setSelected({ ...selected, start_date: moment(dateTo).format("YYYY-MM-DD")}) }
    if(selected?.end_date === "") { setSelected({ ...selected, end_date: moment(dateEnd).format("YYYY-MM-DD")}) }

    // eslint-disable-next-line
  }, [selected])

  return (
    <section>
        <div className="lg:flex overflow-x-auto">
            <div className='flex items-center w-[284px] lg:w-[250px]'>
                <div className="label-text pb-1 font-bold pe-2 lg:w-[145px] w-[350px] uppercase">START DATE</div>
                <DateInput
                    className="!w-[150px]"
                    placeholderText="Date From"
                    onChange={(date) => setSelected({ ...selected, start_date: moment(date).format("YYYY-MM-DD")})}
                    selected={ selected?.start_date ? moment(selected?.start_date).toDate() : null }
                />
            </div>
            <div className='flex items-center w-[284px] lg:w-[250px] mt-2 lg:mt-0'>
                <div className="lg:mt-0 lg:px-2 pb-1 label-text font-bold lg:w-[110px] !w-[550px] uppercase">END DATE</div>
                <DateInput
                    className="!w-[150px]"
                    placeholderText="Date To"
                    onChange={(date) => setSelected({ ...selected, end_date: moment(date).format("YYYY-MM-DD")})}
                    selected={ selected?.end_date ? moment(selected?.end_date).toDate() : null }
                />
            </div>
            <div className='flex items-center ml-1 mt-2 lg:mt-0'>
                <div className="lg:mt-0 lg:px-2 pb-1 label-text font-bold w-[142px] lg:w-full">APPROVAL</div>
                <Select
                    className="w-[150px]"
                    placeholder="Select Location"
                    value={selected?.approve_status !== "" ? [allOption, ...sortedSelectApproval].find((item) => item.value?.toString() === selected?.approve_status?.toString()) : allOption}
                    options={[allOption, ...selectApproval]}
                    onChange={(e) => setSelected({ ...selected, approve_status: e?.value! })}
                />
            </div>
            <div className='flex items-center ml-1 mt-2 lg:mt-0'>
                <div className="lg:mt-0 lg:px-2 pb-1 label-text font-bold w-[142px] lg:w-full">STATUS</div>
                <Select
                    className="w-[150px]"
                    placeholder="Select Location"
                    value={selected?.bill_status !== "" ? [allOption, ...sortedSelectStatus].find((item) => item.value?.toString() === selected?.bill_status?.toString()) : allOption}
                    options={[allOption, ...selectStatus]}
                    onChange={(e) => setSelected({ ...selected, bill_status: e?.value! })}
                />
            </div>
        </div>
        <Input 
            inputClass='w-[300px] mt-5' 
            placeholder='Search data...'  
            value={selected?.search}
            onChange={(e) => setSelected({ ...selected, search: e?.target?.value })}
        />
    </section>
  )
}